module.exports = __webpack_public_path__ + "centos-ad02a041ea9200fa02bd134eeac53278.svg";